import React, { useEffect, useState } from "react";
import {
  Drawer,
  List,
  Typography,
  Toolbar,
  ListItem,
  ListItemIcon,
  ListItemText,
  Grid,
  CircularProgress,
} from "@material-ui/core";
import { SideMenuStyles } from "./SideMenuStyles";
import { setSecureItem } from "../../services/Commons";
import { GetUtilitiesCorreosIdUserAccessControl } from "../../services/UtilitiesCallsService";
import { checkIsNullUndefined } from "../../commons/Utils";
import { EnumPages } from "../../commons/EnumPages";
import { ProfileBar } from "../ProfileBar/ProfileBar";
import { UserMenu } from "./components/UserMenu";
import { EnterpriseMenu } from "./components/EnterpriseMenu";
import { useTranslation } from "react-i18next";
import history from "../../services/history";
import { iconNames, secureValues } from "../../commons/EnumsGeneral";
import { CorreosIcon } from "../CommonComponents/CorreosIcon/CorreosIcon";

export function SideMenu(props) {
  const {
    refreshEnterprises,
    updateUser,
    setUpdateUser,
    setShowSideMenu,
    showSideMenu,
    setResetPage,
    resetPage,
    setIsSpecialUser,
    isSpecialUser,
    enterpriseList,
    setEnterpriseList
  } = props;
  const classes = SideMenuStyles();
  const { t } = useTranslation();

  const [user, setUser] = useState("");
  const [profileProgress, setProfileProgress] = useState(0);
  const [subMenuKey, setSubMenuKey] = useState("");
  const [circularProgress, setCircularProgress] = useState(true);
  const [selected, setSelected] = useState(null);

  const handleListItemClick = (item) => {
    setSelected(item === selected ? null : item);
  };

  useEffect(() => {
    if (updateUser) {
      setUpdateUser(false);
    }
    handleSideMenuData();
  }, [refreshEnterprises, updateUser]);

  const handleSideMenuData = () => {
    let serviceAuxiliaryOptionsValues = [];
    setCircularProgress(true);
    GetUtilitiesCorreosIdUserAccessControl().then((response) => {
      let auxiliaryArray = [];
      if (response && !response.Status) {
        let name = checkIsNullUndefined(response.name)
          ? t("userNameUnregistered")
          : response.name;
        setUser(name);
        serviceAuxiliaryOptionsValues.push({ name: name });
        response.userEnterpriseAssociated.forEach((enterprise, index) => {
          let enterpriseName = !checkIsNullUndefined(enterprise.companyName)
            ? enterprise.companyName
            : !checkIsNullUndefined(enterprise.tradeName)
              ? enterprise.tradeName : t("enterpriseNameUnregistered");
          let auxOption = {
            oid: enterprise.id,
            name: enterpriseName,
            index: index,
            isOrganization: enterprise.isOrganization,
            isTitular: enterprise.idRol == 1,
          };
          auxiliaryArray.push(auxOption);
          serviceAuxiliaryOptionsValues.push(auxOption);
        });
        setProfileProgress(response.percentage);
        setEnterpriseList(auxiliaryArray);
        setSecureItem(secureValues.enterpriseList, response.userEnterpriseAssociated);
        let auxSpecialUser = checkIsNullUndefined(response.special) ? false : response.special;
        setIsSpecialUser(auxSpecialUser);
      };
      setCircularProgress(false);
      if(refreshEnterprises && !checkIsNullUndefined(refreshEnterprises.enterprise)){
        history.push("/Index/" + refreshEnterprises.enterprise + "/" + EnumPages.EnterpriseData);
      };
    });
  };

  const handleCreateEnterpriseClick = () => {
    setShowSideMenu();
    setSubMenuKey(null);
    setResetPage(!resetPage);
    handleListItemClick(t("create"));
    history.push("/Index/" + EnumPages.EnterpriseCreate);
  };

  const handleUserCancelAccountClick = () => {
    setShowSideMenu();
    setSubMenuKey(null);
    handleListItemClick(t("askUnsubscribeService"));
    history.push("/Index/" + EnumPages.UserCancelAccount);
  };

  const handleSubMenuKeys = (key) => {
    setSubMenuKey(key);
  };

  return (
    <Drawer
      className={showSideMenu ? classes.drawer : classes.hideDrawer}
      PaperProps={{ elevation: 6 }}
      variant="permanent"
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <Toolbar />
      <div className={classes.drawerContainer}>
        <Grid className={classes.userGrid}>
          <Typography variant="h6" noWrap className={classes.drawerText}>
            {t("profileComp")}
          </Typography>
          <ProfileBar
            progress={profileProgress}
            tooltip={t("profileComp")}
            className={classes.profileBar}
          />
        </Grid>
        <Grid style={{ height: "35em" }}>
          {circularProgress ? (
            <CircularProgress />
          ) : (
            <Grid>
              <UserMenu
                user={user}
                setShowSideMenu={setShowSideMenu}
                setSubMenuKey={handleSubMenuKeys}
                subMenuKey={subMenuKey}
                setSelected={setSelected}
                setResetPage={setResetPage}
                resetPage={resetPage}
                isSpecialUser={isSpecialUser}
              ></UserMenu>
              {enterpriseList.map((enterprise, index) => {
                return (
                  <EnterpriseMenu
                    key={index}
                    enterprise={enterprise}
                    setShowSideMenu={setShowSideMenu}
                    setSubMenuKey={handleSubMenuKeys}
                    subMenuKey={subMenuKey}
                    setSelected={setSelected}
                    setResetPage={setResetPage}
                    resetPage={resetPage}
                    isSpecialUser={isSpecialUser}
                  ></EnterpriseMenu>
                );
              })
              }
              {((checkIsNullUndefined(isSpecialUser) || !isSpecialUser)) && enterpriseList.length < 3 ? (
                <List key={"create"} className={classes.menuList}>
                  <ListItem
                    button
                    key={t("create")}
                    onClick={() => handleCreateEnterpriseClick()}
                    className={classes.menuListItem}
                    selected={selected === t("create")}

                  >
                    <ListItemIcon className={classes.drawerText}>
                      <CorreosIcon iconSelected={iconNames.enterprise} iconName="Enterprise Icon" iconState="basic" iconScale={2.5} />
                    </ListItemIcon>
                    <ListItemText
                      primary={t("create")}
                      primaryTypographyProps={{ noWrap: true }}
                    />
                  </ListItem>
                </List>
              ) : null}
              <List key={"unsubscribe"} className={classes.menuList}>
                <ListItem
                  button
                  key={t("askUnsubscribeService")}
                  onClick={() => handleUserCancelAccountClick()}
                  className={classes.menuListItem}
                  selected={selected === t("askUnsubscribeService")}
                >
                  <ListItemIcon className={classes.drawerText}>
                    <CorreosIcon iconSelected={iconNames.cancel} iconName="Cancel Icon" iconState="basic" iconScale={2.5} />
                  </ListItemIcon>
                  <ListItemText
                    primary={t("askUnsubscribeService")}
                    primaryTypographyProps={{ noWrap: true }}
                  />
                </ListItem>
              </List>
            </Grid>
          )}
        </Grid>
      </div>
    </Drawer>
  );
}
